import { useEffect, useState } from 'react';
import { API_URL } from '../api';
import type { SiteSectionPayload } from '../components/site/DynamicPageSections';

export function useSiteStructureSections(route: string) {
  const [sections, setSections] = useState<SiteSectionPayload[]>([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const q = encodeURIComponent(route);
        const res = await fetch(`${API_URL}/site-structure/sections?route=${q}`);
        const data = await res.json();
        if (!cancelled && data.success && Array.isArray(data.data)) {
          setSections(data.data);
        } else if (!cancelled) {
          setSections([]);
        }
      } catch {
        if (!cancelled) setSections([]);
      } finally {
        if (!cancelled) setReady(true);
      }
    };
    setReady(false);
    run();
    return () => {
      cancelled = true;
    };
  }, [route]);

  return { sections, ready };
}
